import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { deleteNewsletter, getNewsletter } from "../../../service/api";
import { toast } from "react-toastify";
import { triggerDownload } from "../../../config/downloadUtils";
import { Spinner } from "react-bootstrap";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import { sanitizeInput } from "../../../config/validation";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const ALL_COLUMNS = [
  {
    key: "email",
    title: "Email",
    defaultVisible: true,
    render: (r) => r?.email || "-",
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDateTime(r?.createdAt),
  },
  {
    key: "updatedAt",
    title: "Updated",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.updatedAt),
  },
  {
    key: "id",
    title: "ID",
    defaultVisible: false,
    render: (r) => r?._id || "-",
  },
];

const Newsletter = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "newsletter-list",
    allColumns: ALL_COLUMNS,
  });

  const getList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (startDate) {
      body.startDate = startDate;
    }
    if (endDate) {
      body.endDate = endDate;
    }
    setLoading(true);
    getNewsletter(body)
      .then((res) => {
        if (res?.status) {
          setList(res?.data);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    setDownloadLoading(true);
    getNewsletter(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "newsletter");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteNewsletter(id?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'newsletter-delete-success' });
          handleCloseDelete();
          getList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'newsletter-delete-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'newsletter-delete-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, [page, pageSize, searchTerm, startDate, endDate]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm, startDate, endDate]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <a
          onClick={() => {
            handleOpenDelete();
            setId(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Newsletter</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Newsletter</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={list?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin
                          size="large"
                          style={{ position: "relative", top: "35%" }}
                        />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={list?.result || []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {list && list?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={list?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${
                          loading ? "display-hide" : "display-flex"
                        }`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                count={list?.total}
                onClear={() => {
                  setSearchTerm("");
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="Email"
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(sanitizeInput(e.target.value))
                    }
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker
                    onApply={handleDateRangeChange}
                    isClearable={true}
                  >
                    <input
                      type="text"
                      placeholder="Select date range"
                      readOnly
                    />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
